import { useMemo } from 'react';

// Сортирует дочерние навыки по количеству выбранных флагов.
// Если выбран грейд, дополнительно фильтрует: оставляет навыки, где есть чек на выбранном грейде или левее (по orderNum).
export default function useSortedChildSkills(skillGroups, grades, selectedGradeId) {
  return useMemo(() => {
    const result = {};

    // Используем порядок колонок в grades как "левее/правее"
    const gradeIdToIndex = new Map(); // string id -> index
    const gradeNumIdToIndex = new Map(); // number id -> index
    let selectedIndex;
    if (Array.isArray(grades)) {
      grades.forEach((g, idx) => {
        gradeIdToIndex.set(String(g.id), idx);
        const n = Number(g.id);
        if (!Number.isNaN(n)) gradeNumIdToIndex.set(n, idx);
        if (String(selectedGradeId) === String(g.id)) selectedIndex = idx;
      });
    }

    for (const group of skillGroups) {
      let list = Array.isArray(group.childSkills) ? group.childSkills.slice() : [];
      const parentId = group.parentSkill?.id;

      if (parentId != null) {
        list = list.filter(skill => skill.skillId !== parentId);
      }

      // Сортировка: по количеству выбранных
      list.sort((a, b) => {
        const aMatches = Array.isArray(a.gradeFlags) ? a.gradeFlags.reduce((acc, f) => acc + (f.isChecked ? 1 : 0), 0) : 0;
        const bMatches = Array.isArray(b.gradeFlags) ? b.gradeFlags.reduce((acc, f) => acc + (f.isChecked ? 1 : 0), 0) : 0;
        return bMatches - aMatches;
      });

      // Фильтрация по выбранному грейду: оставляем навыки, где есть чек на выбранном или левее (index <= selectedIndex)
      if (selectedIndex !== undefined) {
        list = list.filter(skill => {
          if (!Array.isArray(skill.gradeFlags)) return false;
          return skill.gradeFlags.some(f => {
            if (!f.isChecked) return false;
            const idx = gradeNumIdToIndex.get(f.gradeId);
            return typeof idx === 'number' && idx <= selectedIndex;
          });
        });
      }

      result[group.parentSkill.id] = list;
    }

    return result;
  }, [skillGroups, grades, selectedGradeId]);
}


